(function () {
    'use strict';
    var controllerId = 'autorizzazioneAddEdit';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', '$filter', 'datacontext', 'common', 'autorizzazione','users', 'roles', autorizzazioneAddEditFn]);

    function autorizzazioneAddEditFn($scope, $uibModalInstance, $filter, datacontext, common, autorizzazione, users, roles) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        $scope.users = users;
        $scope.roles = roles;
        $scope.autorizzazione = autorizzazione;

        $scope.showCosti = false;
        $scope.showProfiliOrari = false;
        $scope.showTeam = false;

        if ($scope.autorizzazione.Id == 0) {   // sono nel nuovo
            $scope.titolo = 'Nuova autorizzazione';
        }
        else {  // sono in modifica
            $scope.titolo = 'Modifica autorizzazione';
            $scope.showCosti = ($scope.autorizzazione && (($scope.autorizzazione.iTags & 2) == 2));
            $scope.showProfiliOrari = ($scope.autorizzazione && (($scope.autorizzazione.iTags & 4) == 4));
            $scope.showTeam = ($scope.autorizzazione && (($scope.autorizzazione.iTags & 8) == 8));
        }

        $scope.area = [ { Name: 'Costi', Value: 2 },
                        { Name: 'Profili Orari', Value: 4 },
                        { Name: 'Team', Value: 8 }
                      ];

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = {};
                if ($scope.autorizzazione.Id == 0) { // sono nel nuovo
                    addItem($scope.autorizzazione).then(function (result) {
                        if (result.Id && result.Id > 0)
                            $uibModalInstance.close(result);
                    });
                }
                else {  // sono in modifica
                    editItem($scope.autorizzazione).then(function (result) { // metto in result l'oggetto tornato dal server a seguito dell'aggiornamento (può essere nullo se non va a buon fine)
                        if (result.Id && result.Id > 0)
                            $uibModalInstance.close(result);
                    });
                }
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        // Modifica elemento
        function editItem(item) {
            return datacontext.authorization_update(item).then(function (data) {
                if (!data || data.Id == null || data.Id == 0) {
                    logError("Errore durante la creazione del dato");            
                    return null;
                }
                return data;                                                    
            });
        }

        // Aggiunta elemento
        function addItem(item) {
            return datacontext.authorization_add(item).then(function (data) {                
                if (!data || data.Id == null || data.Id == 0) {
                    logError("Errore durante la creazione del dato");           
                    return null;
                }

                return data;                                                    
            });
        }

        $scope.calcolaTag = function () {
            var costiCheck = 0;
            var profiliOrariCheck = 0;
            var teamCheck = 0;

            $scope.autorizzazione.iTags = 0;
            if ($scope.showCosti) {
                costiCheck = $scope.area[0].Value;
            }

            if ($scope.showProfiliOrari) {
                profiliOrariCheck = $scope.area[1].Value;
            }

            if ($scope.showTeam) {
                teamCheck = $scope.area[2].Value;
            }

            $scope.autorizzazione.iTags = costiCheck + profiliOrariCheck + teamCheck;
            //$("input:checkbox[name=areaTag]:checked").each(function () {
            //    areaList.push($(this).val());
            //});
            //areaList.forEach(function (item) {
            //    $scope.autorizzazione.iTags += parseInt(item);
            //}); 
        }
    }
})();